const $ = window.jQuery;

$(document).ready(function() {
    captionSize();
    $(window).on('resize', function() {
        captionSize();
    });
    function captionSize() {
        $('.wp-block-image').each(function() {
            var width = $(this).children('img').width()
            $(this).children('figcaption').css('width', width+'px');
        });
    }
});